module.exports = __webpack_public_path__ + "assets/img/1.3a2da1d9.jpg";